<template>
    <div class="inline" @dblclick="toggleEditable">
        <div class="inline" v-if="isEditable">
            <input @input="createNewInvoicesRecordedLog" v-model="invoicesRecordedLogData.recorded_date" type="date" class="border p-1">
        </div>
        <div class="inline" v-else>
            {{ receiptsRecordedAsOfDate }}
        </div>
    </div>
</template>

<script setup>
import { computed, ref, reactive, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { formatDateTwoDigitYear } from '@/composables/formatDate';
import { createInvoicesRecordedLog } from '@/services/InvoicesRecordedLog';
import { useToast } from 'vue-toast-notification';

const store = useStore()
const $toast = useToast()
const props = defineProps([
    'mostRecentInvoiceRecordedLog'
])
const emit = defineEmits(['refetch-invoices'])
const isEditable = ref(false)
const receiptsRecordedAsOfDate = computed(() => {
  if(props.mostRecentInvoiceRecordedLog) {
    return formatDateTwoDigitYear(props.mostRecentInvoiceRecordedLog.recorded_date)
  } else {
    return '--'
  }
})

const invoicesRecordedLogData = reactive({
    recorded_date: null,
    user_id: store.state.auth.user.id
})


function toggleEditable(){
    const perms = store.state.auth.userPermissions
    if(perms.isAccountingGroup || perms.isDev || perms.isSuperuser){
        isEditable.value = !isEditable.value
    }
}

async function createNewInvoicesRecordedLog(){
    const token = store.state.auth.token
    const response = await createInvoicesRecordedLog(token, invoicesRecordedLogData)
    console.log('response', response)
    if(response.status == 201){
        $toast.open({
            message: 'Successfully added new Invoices Recorded Log',
            type: 'success',
            duration: 3000
        })
        emit('refetch-invoices')
        isEditable.value = false
        invoicesRecordedLogData.recorded_date = null
    } else {
        $toast.open({
            message: 'Error, could not add new Invoices Recorded Log',
            type: 'error',
            duration: 3000
        })
    }
}


</script>